import { parseMarkdown } from "components/Form/Editor/Plugins/withMarkdown";

/**
 * Converts markdown text to Slate JSON format
 * @param {string} markdown - Markdown text
 *
 * @returns {Array} Slate nodes
 */
export const markdownToSlate = (markdown) => {
  if (!markdown) return [{ type: "paragraph", children: [{ text: "" }] }];

  return parseMarkdown(markdown);
};

/**
 * Strips markdown formatting from text (for titles, plain text display)
 * @param {string} text - Text with markdown
 *
 * @returns {string} Plain text without markdown formatting
 */
export const stripMarkdown = (text) => {
  if (!text) return "";

  return text
    .replace(/\*\*\*([^*]+)\*\*\*/g, "$1") // ***bold+italic***
    .replace(/\*\*([^*]+)\*\*/g, "$1") // **bold**
    .replace(/\*([^*]+)\*/g, "$1") // *italic*
    .replace(/__([^_]+)__/g, "$1") // __underline__
    .replace(/_([^_]+)_/g, "$1") // _underline_
    .replace(/^#+\s+/gm, "") // # headings
    .trim();
};
